export default __webpack_public_path__ + "static/media/logo-us-underarmour.727a1678.svg";